import PageHandler from "./PageHandler";
import Pages from "Pages";

class CustomersListPageHandler extends PageHandler {
  constructor() {
    super("customers-list", Pages.CustomersListPage);
  }

  fetch() {
    this.rootStore.data.CustomersStore.fetch();
  }
}

export default CustomersListPageHandler;



// WEBPACK FOOTER //
// ./src/Stores/UIStore/PageHandlers/CustomersListPageHandler.js